module.exports = __webpack_public_path__ + "img/album21_23.cef8bac5.jpg";